import { render, staticRenderFns } from "./PrintOrderCopyRecipients.vue?vue&type=template&id=1b77bc6a"
import script from "./PrintOrderCopyRecipients.vue?vue&type=script&lang=js"
export * from "./PrintOrderCopyRecipients.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports